import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  deliveryAddress: null,
  deliveryType: null,
};

const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setDeliveryAddress: (state, action) => {
      state.deliveryAddress = action.payload;
    },
    setDeliveryType: (state, action) => {
      state.deliveryType = action.payload;
    },
    deleteDeliveryAddress: (state, action) => {
      const deletedId = action.payload;
      if (state.deliveryAddress?.id === deletedId) {
        state.deliveryAddress = null;
      }
    },
    clearDelivery: (state) => {
      state.deliveryAddress = null;
      state.deliveryType = null;
    },
  },
});

export const {
  setDeliveryAddress,
  setDeliveryType,
  deleteDeliveryAddress,
  clearDelivery,
} = deliverySlice.actions;

export default deliverySlice.reducer;

// Selectors
export const selectDeliveryAddress = (state) => state.delivery.deliveryAddress;
export const selectDeliveryType = (state) => state.delivery.deliveryType;
